import { render, staticRenderFns } from "./addPromoVoucher.vue?vue&type=template&id=158214d7&lang=pug"
import script from "./addPromoVoucher.vue?vue&type=script&lang=js"
export * from "./addPromoVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports